import * as fragments from './fragments'
import * as sections from './section-queries'

//QUERIES
export const getSettings = groq`
    * [_type == "settings"][0] {
      errorPage {
        text,
        ${fragments.media},
      },
}
`

export const getFooter = groq`
  *[_type == "footer"][0] {
    
    mainMenu[] {
      _type == "linkNotToOverlay" => ${fragments.callToAction},
    },
    additionalLinks[] {
      _type == "linkNotToOverlay" => ${fragments.callToAction},
    },
    socialMedias[] {
      ...socialMedia {
        title,
        svgIcon,
        url
      },
    },
    loginLink {
      _type == "link" => ${fragments.callToAction},
    },
  }`

export const getPages = groq`
  * [_type == "page"] {
    ...,
  "slug": '/' + slug.current,
  }
`

export const getFrontpage = groq`*[_type == "frontpage"][0] {
  ...${fragments.pageDefaults},
  
 "seo": ${seo},
 ${sections.builder},
}`
export const getGetStarted = groq`*[_type == "getStarted"][0] {
  ...${fragments.pageDefaults},
  
 "seo": ${seo},
 ${sections.builder},
}`

export const getPage = groq`* [slug.current == $slug][0] {
  ...,
  ...${fragments.pageDefaults},
  "seo": ${seo},
  ${sections.builder},
}`

export const getPagesFromIds = groq`* [_type in $documentTypes && _id in $ids] {
    ...${fragments.pageDefaults},
} `

export const getAllBlogs = groq`
  *[_type == "blog"] | order(date desc) {
    title,
    category,
    description,
    "slug": slug.current,
    date,
    media { ...${fragments.mediaLight} },
   text[] { ...${fragments.portableTextMultiple} }
  }
`
